"use client";

import Image from "next/image";
import { SignInButton, SignInButtonVariants } from "../SignInButton";
import {
  trackingDetails,
  ClientTrackingEvent,
  ClientTrackingArea,
} from "@/components/helpers/event-tracking-helpers";

export interface IUpsellLoginBanner {
  bannerText: string;
  buttonText: string;
}

export const UpsellLoginBanner = (props: IUpsellLoginBanner) => {
  const { bannerText, buttonText } = props;
  return (
    <div
      automation-id="upsell-message-login-banner"
      className="flex w-full flex-col items-center justify-between rounded-lg bg-white px-3 py-2 sm:flex-row"
    >
      <div
        automation-id="upsell-message-login-banner-text"
        className="flex items-center gap-x-[6px] font-sans text-p-14"
      >
        <Image src={"/lock-image.svg"} width={24} height={24} alt={""}></Image>
        {bannerText}
      </div>
      <SignInButton
        signInButtonVariant={SignInButtonVariants.buttonVariant}
        data-track-click
        data-track-details={trackingDetails({
          event: ClientTrackingEvent.SIGN_IN_CLICKED,
          area: ClientTrackingArea.UPSELL,
        })}
      >
        {buttonText}
      </SignInButton>
    </div>
  );
};
